// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"7d2ba49a","176":"246e5db9","198":"1223ff04","796":"1a296f6a","916":"95873993"}[chunkId] + ".chunk.js";
};